import React from 'react';
import PropTypes from 'prop-types';

const ExperienceList = ({ expertiseCategories }) => (
    <div className="experience-list">
        {expertiseCategories.map((item, i) => (
            <span className="experience-list__item" key={item.id}>
                {i > 0 && ', '}
                {item.name}
            </span>
        ))}
    </div>
);

ExperienceList.defaultProps = {
    expertiseCategories: [],
};

ExperienceList.propTypes = {
    expertiseCategories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
        })
    ),
};

export default ExperienceList;



// WEBPACK FOOTER //
// ./src/js/components/Designers/ExperienceList.jsx